import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment/moment";
import BackLink from "../../HelperComponents/BackLink/BackLink";
import DefaultButton from "../../Buttons/DefaultButton/DefaultButton";
import TransitionedBlock from "../../HelperComponents/TransitionedBlock/TransitionedBlock";
import Loader from "../../HelperComponents/Loader/Loader";
import SnackBar from "../../HelperComponents/SnackBar/SnackBar";
import StatusDot from "../../HelperComponents/StatusDot/StatusDot";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import Checkbox from "@material-ui/core/Checkbox";

import {
  getSpecificReturnDispatch,
  approveReturnDispatch,
  offerReturnDispatchProductToStock,
} from "../../../actions/returnDispatchesActions";
import { formatPrice, getPositionStatusColor } from "../../../helpers/functions";
import ReturnDispatchOfferToStockDialog from "../ReturnDispatchOfferToStockDialog/ReturnDispatchOfferToStockDialog";

import "./ReturnDispatchesItems.scss";

class ReturnDispatchesItems extends Component {
  state = {
    loading: true,
    selectedItems: [],
    loadingBtn: false,
    highlightRefundRequest: null,
    highlightArticle: null,
    highlightOrder: null,
    stockDialogProduct: null,
    stockLoading: false,
    notification: {
      open: false,
      type: "success",
      message: "",
    },
  };

  componentDidMount = () => {
    this.doRequest();
    const params = new URLSearchParams(this.props.location.search);
    const highlightRefundRequest = params.get('highlightRefundRequest');
    const highlightArticle = params.get('highlightArticle');
    const highlightOrder = params.get('highlightOrder');
    if (highlightRefundRequest) {
      this.setState({
        highlightRefundRequest: Number(highlightRefundRequest),
        highlightArticle,
        highlightOrder,
      });
      setTimeout(() => {
        this.setState({ highlightRefundRequest: null, highlightArticle: null, highlightOrder: null });
      }, 3000);
    }
  };

  doRequest = () => {
    const {
      match: { params },
      getSpecificReturnDispatch,
    } = this.props;
    getSpecificReturnDispatch(params.id).then((res) => {
      if (res.payload && res.payload.status && res.payload.status === 200) {
        this.setState({
          loading: false,
          selectedItems: [],
        });
      } else {
        this.props.history.push({
          pathname: '/admin/return-dispatches',
          state: {
            isVsibleSnackBar: true,
            snackBarMessage: 'При получении данных по выдаче возвратов возникла ошибка. Повторите попытку позже',
          }
        });
      }
    });
  };

  isHighlighted = (product) => {
    const { highlightRefundRequest, highlightArticle, highlightOrder } = this.state;
    return highlightRefundRequest
      && product.related_refund_request === highlightRefundRequest
      && product.article_number === highlightArticle
      && String(product.ordernum) === String(highlightOrder);
  };

  isSelectable = (product) => {
    return product.item_status === 'На рассмотрении'
      || product.item_status === 'На рассмотрение'
      || product.item_status === 'Ожидает обработки';
  };

  toggleItem = (id) => {
    this.setState(({ selectedItems }) => {
      if (selectedItems.includes(id)) {
        return { selectedItems: selectedItems.filter(item => item !== id) };
      }
      return { selectedItems: [...selectedItems, id] };
    });
  };

  selectAll = () => {
    const { return_dispatches: { return_dispatch } } = this.props;
    if (!return_dispatch.products) return;
    const selectableIds = return_dispatch.products
      .filter(this.isSelectable)
      .map(p => p.id);
    this.setState({ selectedItems: selectableIds });
  };

  getSelectedSum = () => {
    const { return_dispatches: { return_dispatch } } = this.props;
    const { selectedItems } = this.state;
    if (!return_dispatch.products) return 0;
    return return_dispatch.products
      .filter(p => selectedItems.includes(p.id))
      .reduce((sum, p) => sum + (Number(p.total_sum) || 0), 0);
  };

  getSelectedProducts = () => {
    const { return_dispatches: { return_dispatch } } = this.props;
    if (!return_dispatch.products) return [];
    return return_dispatch.products.filter((product) => (
      this.state.selectedItems.includes(product.id)
    ));
  };

  getActionError = (response, fallback) => {
    const errorData = response
      && response.error
      && response.error.response
      && response.error.response.data;
    const error = errorData && (errorData.error || errorData.detail);

    if (Array.isArray(error)) return error.join(', ');
    return error || fallback;
  };

  showActionResult = (response, successMessage) => {
    const status = response && response.payload && response.payload.status;
    const success = status >= 200 && status < 300;

    this.setState({
      loadingBtn: false,
      stockLoading: false,
      stockDialogProduct: null,
      notification: {
        open: true,
        type: success ? 'success' : 'error',
        message: success
          ? successMessage
          : this.getActionError(response, 'Не удалось обработать товары. Список обновлён.'),
      },
    }, this.doRequest);
  };

  handleApprove = () => {
    const {
      match: { params },
      approveReturnDispatch,
    } = this.props;
    const { selectedItems } = this.state;
    if (selectedItems.length === 0) return;

    const data = {
      items: selectedItems.map(id => ({ dispatch_product_id: id }))
    };

    this.setState({ loadingBtn: true });
    approveReturnDispatch({
      ...data,
      dispatch_id: Number(params.id),
    }).then((response) => {
      this.showActionResult(response, 'Выбранные товары одобрены');
    });
  };

  openStockDialog = () => {
    const selectedProducts = this.getSelectedProducts();
    if (selectedProducts.length !== 1) return;

    this.setState({ stockDialogProduct: selectedProducts[0] });
  };

  handleApproveToStock = (data) => {
    this.setState({ stockLoading: true });
    this.props.offerReturnDispatchProductToStock(data).then((response) => {
      this.showActionResult(response, 'Товар одобрен на склад');
    });
  };

  render() {
    const {
      return_dispatches: { return_dispatch },
    } = this.props;
    const {
      loading,
      loadingBtn,
      notification,
      selectedItems,
      stockDialogProduct,
      stockLoading,
    } = this.state;

    if (loading) return <Loader />;

    return (
      <TransitionedBlock>
        <div className="item_page container">
          <div className="flex-center-btw title-block-page">
            <div className="title-page">
              <BackLink />
              <h1>
                {return_dispatch.supplier}{" "}
                {moment(return_dispatch.dispatch_at).format("DD.MM.YYYY")}
              </h1>
            </div>
          </div>
          <div className="item_page_block">
            <div className="return_dispatch_detail">
              {return_dispatch.products &&
                return_dispatch.products.some(this.isSelectable) && (
                  <div className="return_dispatch_approve_bar">
                    <div className="approve_sum">
                      {formatPrice(this.getSelectedSum())}
                    </div>
                    <DefaultButton onClick={this.selectAll}>
                      ДОБАВИТЬ ВСЕ
                    </DefaultButton>
                    <DefaultButton
                      disabled={loadingBtn || stockLoading || selectedItems.length !== 1}
                      onClick={this.openStockDialog}
                    >
                      ОДОБРИТЬ НА СКЛАД
                    </DefaultButton>
                    <DefaultButton
                      variant="contained_green"
                      loading={loadingBtn}
                      disabled={loadingBtn || stockLoading || selectedItems.length === 0}
                      onClick={this.handleApprove}
                    >
                      ОДОБРИТЬ
                    </DefaultButton>
                  </div>
                )}
              <div className="return_dispatch_table">
                <div className="table_container transactions_columns">
                  <div className="table_header">
                    <div className="table_row">
                      <div className="row_item">Артикул</div>
                      <div className="row_item">Производитель</div>
                      <div className="row_item">Наименование</div>
                      <div className="row_item">Заказ</div>
                      <div className="row_item">Кол-во</div>
                      <div className="row_item">Цена</div>
                      <div className="row_item">Сумма</div>
                      <div className="row_item">Статус</div>
                      <div className="row_item"></div>
                    </div>
                  </div>
                  <div className="table_body">
                    {return_dispatch.products &&
                      return_dispatch.products.map((product) => (
                        <div
                          className={`table_row${
                            this.isHighlighted(product)
                              ? " highlighted_row"
                              : ""
                          }`}
                          key={product.id}
                        >
                          <div className="row_item">
                            {product.article_number}
                          </div>
                          <div className="row_item">{product.producer}</div>
                          <div className="row_item">{product.name}</div>
                          <div className="row_item">{product.ordernum}</div>
                          <div className="row_item">{product.amount}</div>
                          <div className="row_item">
                            {formatPrice(product.unit_price)}
                          </div>
                          <div className="row_item">
                            {formatPrice(product.total_sum)}
                          </div>
                          <div className="row_item status_cell">
                            <span className="status_cell_text">
                              <StatusDot
                                color={getPositionStatusColor(
                                  product.item_status,
                                )}
                              />
                              {product.item_status}
                            </span>
                            {product.related_refund_request && (
                              <span className="status_cell_links">
                                <Link
                                  to={`/admin/refund-request/${
                                    product.related_refund_request
                                  }?highlightArticle=${encodeURIComponent(
                                    product.article_number,
                                  )}&highlightOrder=${
                                    product.ordernum
                                  }&highlightDispatchId=${
                                    this.props.match.params.id
                                  }`}
                                  className="related_link_icon"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <OpenInNewIcon
                                    style={{ fontSize: 16, color: "#0253B3" }}
                                  />
                                </Link>
                              </span>
                            )}
                          </div>
                          <div className="row_item checkbox_cell">
                            {this.isSelectable(product) && (
                              <Checkbox
                                checked={selectedItems.includes(product.id)}
                                onChange={() => this.toggleItem(product.id)}
                              />
                            )}
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ReturnDispatchOfferToStockDialog
            open={!!stockDialogProduct}
            product={stockDialogProduct}
            loading={stockLoading}
            onClose={() => this.setState({ stockDialogProduct: null })}
            onSubmit={this.handleApproveToStock}
          />
          <SnackBar
            open={notification.open}
            classes={notification.type}
            vertical="top"
            onClose={() => this.setState({
              notification: { ...notification, open: false },
            })}
          >
            {notification.message}
          </SnackBar>
        </div>
      </TransitionedBlock>
    );
  }
}

const mapStateToProps = ({ return_dispatches }) => ({
  return_dispatches,
});

const mapDispatchToProps = {
  getSpecificReturnDispatch,
  approveReturnDispatch,
  offerReturnDispatchProductToStock,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReturnDispatchesItems);
